import React from "react";
import Filter from '../../../components/CRM/Filter';
import {connect} from "react-redux";
import DateInput from "../../../components/CRM/DateInput";
import TextInput from "../../../components/CRM/TextInput";

const AdminFilterBase = props => {

  return (
    <Filter {...props}>
      <TextInput
        label="resources.admins.inputs.email"
        source="email_like"
      />
      <DateInput
        label="resources.admins.fields.createdAt"
        source="created_at_on_date"
      />
      <DateInput
        label="resources.admins.fields.updatedAt"
        source="updated_at_on_date"
      />
    </Filter>
  );
};

const mapStateToProps = state => {
  return {
    record: state.admin.resources.admins
  };
};

const AdminFilter = connect(mapStateToProps)(AdminFilterBase);

export default AdminFilter;



// WEBPACK FOOTER //
// ./src/containers/CRM/Admins/AdminsFilter.js